import { Controller } from '@hotwired/stimulus';
import Overlay from '@/libs/cifra/overlay';

export default class extends Controller {
  connect() {
    this.overlay = new Overlay(this.element);

    this.requestListener = document.addEventListener('turbo:before-fetch-request', () => {
      this.overlay.show();
    });
    this.responseListener = document.addEventListener('turbo:before-fetch-response', () => {
      this.overlay.hide();
    });
  }

  disconnect() {
    document.removeEventListener('turbo:before-fetch-request', this.requestListener);
    document.removeEventListener('turbo:before-fetch-response', this.responseListener);
  }
}
